import React from "react";
import { useTranslation } from "react-i18next";

const FormTitleMain = () => {
  const { t } = useTranslation();
  return <h6 className="mb-0">{t("productsForm.basicInfo")}</h6>;
};

export default FormTitleMain;
